<template>
  <div>
    <div class="Content">
      <event-stage-header />
      <main class="SectionContainer u-flex">
        <section :class="[{'is-loading': ui.isLoading} , 'SectionContainer-left']">
          <web-form-renderer
            v-if="event.type === 'static'"
            read-only
          />
          <dynamic-form-renderer-read-only v-else />
        </section>
        <section class="SectionContainer-right">
          <header-creation-steps
            selected="Automations"
            :event="event"
          />
          <h2>Automations</h2>
          <p>
            Define a series of automations that will allow you to tailor the email journey a user is sent when certain
            moments happens.
          </p>

          <!-- On Registration-->

          <div
            class="Automations-container"
          >
            <rmp-autocomplete-select
              v-model="automation_for_on_registration_email"
              :items="listOfOptionsForEmailWorkflows(automation_for_on_registration_email, 'registration')"
              label="On Registration"
              placeholder="Select an email journey"
              :hint="{hint: 'Happens when the user registers.', type: 'info'}"
            />

            <div
              v-if="automation_for_on_registration_email !== null"
              class="TestEmailAutomation"
            >
              <button
                class="Button Button--transparent"
                type="submit"
                title="Your email will be sent to the email journey."
                @click="sendTestToAutomation(automation_for_on_registration_email)"
              >
                <span class="Icon Icon-paper-plane" /> Test Email Journey
              </button>
            </div>
          </div>

          <!-- When Form ends -->

          <div class="Automations-container">
            <rmp-autocomplete-select
              v-model="automation_for_when_form_ends"
              :items="listOfOptionsForEmailWorkflows(automation_for_when_form_ends,'when_form_ends')"
              label="When Event Ends"
              placeholder="Select an email journey"
              :hint="{hint: 'Happens on event date, at midnight.', type: 'info'}"
            />

            <div
              v-if="automation_for_when_form_ends !== null"
              class="TestEmailAutomation"
            >
              <button
                class="Button Button--transparent"
                type="submit"
                title="Your email will be sent to the email journey."
                @click="sendTestToAutomation(automation_for_when_form_ends)"
              >
                <span class="Icon Icon-paper-plane" /> Test Email Journey
              </button>
            </div>
          </div>

          <!-- Scheduled Automations -->

          <div
            v-for="(singleAutomationForAtGivenDateAndTime, tIndex) in automations_for_scheduled"
            :key="tIndex"
            class=""
          >
            <div
              class="Automations-container"
              style="position: relative"
            >
              <div class="ScheduledAutomation-Delete">
                <button
                  title="Delete scheduled automation"
                  @click="removeScheduledAutomation(tIndex,'scheduled')"
                >
                  <span
                    title="Delete scheduled automation"
                    class="Icon Icon-trash"
                  />
                </button>
              </div>
              <rmp-autocomplete-select
                v-model="singleAutomationForAtGivenDateAndTime.id"
                index="id"
                class="u-noMargin"
                option-key="name"
                :items="listOfOptionsForEmailWorkflows(singleAutomationForAtGivenDateAndTime, 'scheduled')"
                :label="labelForScheduledAutomation(tIndex)"
                placeholder="Select an email journey"
                :hint="{hint: 'Happens at a given date/time, Timezone is Europe/London.', type: 'info'}"
              />

              <div
                v-if="singleAutomationForAtGivenDateAndTime.id !== null"
                class="Form-group ScheduledAutomation-DateTime-Container"
              >
                <rmp-date-picker
                  v-model="singleAutomationForAtGivenDateAndTime.date"
                  :required="true"
                  placeholder="DD/MM/YY"
                  label="Date"
                  :clearable="true"
                  :disable-dates="{}"
                  class="ScheduledAutomation-DateTime-Date"
                  :manual-validate="false"
                />
                <rmp-select
                  v-model="singleAutomationForAtGivenDateAndTime.hour"
                  :items="getNumberArray(1,23,1)"
                  class="ScheduledAutomation-DateTime-Hour"
                  label="Hour"
                  :required="true"
                />
                <rmp-select
                  v-model="singleAutomationForAtGivenDateAndTime.minutes"
                  :items="getNumberArray(0,55,5)"
                  class="ScheduledAutomation-DateTime-Minutes"
                  label="Minutes"
                  :required="true"
                />
              </div>
              <div
                v-if="singleAutomationForAtGivenDateAndTime.id !== null"
                class="TestEmailAutomation"
              >
                <button
                  class="Button Button--transparent"
                  type="submit"
                  title="Your email will be sent to the email journey."
                  @click="sendTestToAutomation(singleAutomationForAtGivenDateAndTime)"
                >
                  <span class="Icon Icon-paper-plane" /> Test Email Journey
                </button>
              </div>
            </div>
          </div>
          <button
            class="Button Button--green-outline ScheduledAutomation-Add"
            @click="addScheduledAutomation()"
          >
            <span class="Icon Icon-plus" /> Add Scheduled Automation
          </button>
        </section>
      </main>
      <footer-creation-buttons v-if="isEventCreation">
        <template #left-aligned-buttons>
          <router-link :to="{ name: routeName, params: { id: $route.params.id }}">
            <button class="Button Button--green-outline">
              Back
            </button>
          </router-link>
        </template>
        <template #right-aligned-buttons>
          <button
            :class="[{'is-loading': ui.submitLoading }, 'Button Button--green']"
            @click="handleSubmit"
          >
            Save Event
          </button>
        </template>
      </footer-creation-buttons>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import RmpAutocompleteSelect from '@rmpenterprise/form-autocomplete-select';
import RmpSelect from '@rmpenterprise/form-select';
import RmpDatePicker from '@rmpenterprise/form-date-picker';
import EventStageHeader from '../common/event-stage-header';
import HeaderCreationSteps from '../common/header-creation-steps.vue';
import FooterCreationButtons from '../common/footer-creation-buttons.vue';
import WebFormRenderer from '../static-web-forms/static-form-renderer.vue';
import DynamicFormRendererReadOnly from '../dynamic-web-forms/dynamic-form-renderer/dynamic-form-renderer-read-only';
import dateTransformationsMixin from '../../../mixins/date-transformations';

export default {
  components: {
    RmpDatePicker,
    RmpSelect,
    EventStageHeader,
    HeaderCreationSteps,
    FooterCreationButtons,
    WebFormRenderer,
    DynamicFormRendererReadOnly,
    RmpAutocompleteSelect,
  },
  mixins: [dateTransformationsMixin],
  data() {
    return {
      automation_for_on_registration_email: null,
      automation_for_when_form_ends: null,
      automations_for_scheduled: [],
      ui: {
        isLoading: false,
        submitLoading: false,
      },
    };
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
      emailWorkflows: (state) => state.lists.automations,
    }),
    isEventCreation() {
      return this.$route.path.indexOf('create-event') > -1;
    },
    routeName() {
      return this.event.type === 'dynamic' ? 'messages-dynamic-form' : 'messages';
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.$route.params.id !== undefined) {
      this.ui.isLoading = true;

      this.getEvent(this.$route.params.id)
        .then(() => {
          if (this.event.is_locked) {
            this.$router.push({ name: 'event-records', params: { eventId: this.event.id } });
          } else {
            if (this.event.type === 'dynamic') {
              this.populateScreens();
            }
            this.ui.isLoading = false;
            this.automation_for_on_registration_email = this.event.automations.on_registration_email;
            this.automation_for_when_form_ends = this.event.automations.when_form_ends;
            this.automations_for_scheduled = this.event.automations.scheduled.map(((automation) => {
              return { ...automation, ...{ date: this.transformDateFromStringToDateObject(automation.date) } };
            }));
          }
        })

        .catch(({ data }) => {
          this.ui.isLoading = false;
          this.$bus.$emit('displayMsg', {
            text: data.message,
            type: 'warning',
          });
        });
    }
  },
  methods: {
    ...mapActions('events', ['getEvent', 'updateEvent', 'sendEmailTest']),
    ...mapMutations('forms', ['setFormScreens']),

    /**
     * By default, paused email workflows on Instiller are not included in the select options.
     * However, a Connect automation might be associated with a paused email workflow on Instiller.
     *  eg: Connect automation was set and later on the email workflow on Instiller was paused
     * This method complements the default email workflows available to the select by including the paused
     * workflow.
     *
     * @param automation The automation defined in Connect
     * @param type The type of automation defined in Connect
     * @returns {*|unknown[]} The list of active email workflows on Instiller + current selection
     */
    listOfOptionsForEmailWorkflows(automation, type) {
      // User adds a new scheduled automation
      if (automation === null) {
        return this.emailWorkflows;
      }

      const isAutomationActive = this.emailWorkflows.filter((workflow) => workflow.id === automation.id).length > 0;

      if (isAutomationActive) {
        return this.emailWorkflows;
      }

      const listOfActiveWorkflows = Object.values(this.emailWorkflows);

      if (type === 'registration') {
        listOfActiveWorkflows.push({
          id: this.automation_for_on_registration_email.id,
          name: this.automation_for_on_registration_email.name,
          description: this.automation_for_on_registration_email.description,
        });

        return listOfActiveWorkflows;
      }

      if (type === 'when_form_ends') {
        listOfActiveWorkflows.push({
          id: this.automation_for_when_form_ends.id,
          name: this.automation_for_when_form_ends.name,
          description: this.automation_for_when_form_ends.description,
        });

        return listOfActiveWorkflows;
      }

      const workflow = this.automations_for_scheduled.filter((scheduledWorkflow) => scheduledWorkflow.id === automation.id);

      listOfActiveWorkflows.push({ id: workflow[0].id, name: workflow[0].name, description: workflow[0].description });

      return listOfActiveWorkflows;
    },

    labelForScheduledAutomation(number) {
      return `${number + 1}) Scheduled`;
    },

    removeScheduledAutomation(index) {
      this.automations_for_scheduled = [
        ...this.automations_for_scheduled.slice(0, index),
        ...this.automations_for_scheduled.slice(index + 1),
      ];
    },
    addScheduledAutomation() {
      this.automations_for_scheduled.push(
        {
          id: null,
          name: null,
          date: null,
          hour: null,
          minutes: null,
        },
      );
    },
    populateScreens() {
      if (this.event.questions.length) this.setFormScreens();
    },
    handleSubmit() {
      this.ui.submitLoading = true;

      const scheduledAutomations = this.automations_for_scheduled.map(((automation) => {
        return {
          ...automation,
          ...{
            date: this.transformDateObjectIntoDateAsString(automation.date),
          },
        };
      }));

      const payload = {
        ...this.event,
        automations: {
          on_registration_email: this.automation_for_on_registration_email,
          when_form_ends: this.automation_for_when_form_ends,
          scheduled: scheduledAutomations.length > 0 ? scheduledAutomations : null,
        },
      };
      this.updateEvent(payload)
        .then(() => {
          this.ui.submitLoading = false;
          this.$bus.$emit('displayMsg', {
            text: 'Event Saved!',
            type: 'success',
          });

          setTimeout(() => {
            this.$router.push({ name: 'event-records', params: { eventId: this.event.id } });
          }, 2000);
        })
        .catch(({ data }) => {
          this.ui.submitLoading = false;
          let { message } = data.data;
          if (data.meta && data.meta[0]) {
            message = data.meta[0].message;
          }
          this.$bus.$emit('displayMsg', {
            text: message,
            type: 'error',
            time: 10000,
          });
        });
    },
    getNumberArray(start, end, increment = 1) {
      const len = Math.floor((end - start) / increment) + 1;
      // Get numbers and add 0 to any number that's less than 2
      return Array(len).fill().map((_, index) => String(start + (index * increment)).padStart(2, 0));
    },
    sendTestToAutomation(automation) {
      this.ui.submitLoading = true;
      const payload = {
        automationId: automation.id,
      };
      this.sendEmailTest(payload)
        .then((response) => {
          this.ui.submitLoading = false;
          this.$bus.$emit('displayMsg', {
            text: response.message,
            type: 'success',
          });
        })
        .catch((response) => {
          this.ui.submitLoading = false;
          this.$bus.$emit('displayMsg', {
            text: response.data.data.message,
            type: 'error',
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>

.SectionContainer-left {
  background: #F7F8F9 !important;
}

.SectionContainer-right {
  position: relative;
}

.ScheduledAutomation-Add {
  margin-bottom: 25px;
}

.Automations-container {
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 20px;
  margin-bottom: 25px;

  .ScheduledAutomation-Delete {
    position: absolute;
    right: 0;
    top: -5px;
    padding: 10px;
  }

  .ScheduledAutomation-DateTime-Container {
    margin-bottom: 0;
    margin-top: 15px;
  }

  .ScheduledAutomation-DateTime-Date {
    width: 30% !important;
    margin-bottom: 0;
  }

  .ScheduledAutomation-DateTime-Hour {
    width: 25% !important;
    margin-right: 10px;
    margin-left: 10px !important;
    margin-bottom: 0;
  }

  .ScheduledAutomation-DateTime-Minutes {
    width: 25% !important;
    margin-bottom: 0;
  }

  .TestEmailAutomation {
    margin-top: 15px;

    .Button {
      font-size: 12px;
    }
  }

  ::v-deep .Hint {
    margin-top: 10px;
  }

  ::v-deep .Form-label {
    margin-bottom: 8px !important;
    color: #083555;
    font-weight: 400;
    font-size: 15px;
  }

  ::v-deep .Hint--warning {
    margin-top: 10px;
  }

  ::v-deep .Form-autoComplete {
    margin-bottom: 0;
  }
}

.Section--flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  &::before,
  &::after {
    display: none;
  }
}
</style>
